import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
  getOptions,
} from "../../../Redux/actions/crudActions";
import { errorParser } from "../../../utils/helpers";
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({
  blueprint,
  mode,
  token,
  value,
  onChange,
  onChangeName,
  currentItem,
}) => {
  const dispatch = useDispatch();
  const FormRef = useRef();
  const {} = useSelector((state) => ({}), shallowEqual);

  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (blueprint) {
      if (mode == "options" || mode == "options-multiple") {
        getCurrentOptions(null);
      }
    }
  }, [blueprint]);

  const getCurrentOptions = (search) => {
    setLoading(true);
    var apiurl = blueprint.api;
    var searchText = "";

    var requestData = {
      apiurl: apiurl,
    };
    if (search !== null) {
      requestData["searchText"] = search;
    }

    console.log("requestData", requestData);
    dispatch(getOptions(requestData))
      .then((documentSnapshots) => {
        var docs = documentSnapshots.docs;
        var dataArray = [];
        docs.map((item) => {
          var newOrder = {
            key: item.id,
            id: item.id,
            ...item.data(),
          };

          dataArray.push(newOrder);
        });

        if (dataArray) {
          console.log("dataArray", dataArray);
          setOptions(dataArray);
        } else {
          message.error(`error retreiving ${blueprint.title} options`);
        }

        setLoading(false);
      })
      .catch((err) => {
        if (err) {
          message.error(`error retreiving ${blueprint.title} options`);
        }
        setLoading(false);
      });
  };

  const changesMade = (val, option) => {
    // console.log(option)

    if (mode == "options-multiple") {
      var newname = [];
      option.map((item) => {
        newname.push(item.children);
      });
      onChangeName(newname);
    } else {
      if (option) {
        onChangeName(option.children);
      }
    }
    onChange(val);
  };

  const renderOptions = () => {
    if (options) {
      var optionsList = Object.entries(options).map(([key, value2]) => {
        var optionName = "";
        if (value2.name) {
          optionName = value2.name;
          if (blueprint.key == "product") {
            if (value2.description) {
              optionName = `${value2.name} → ${value2.description}`;
            }
          }
        } else if (value2.game_name) {
          optionName = value2.first_name;
        } else if (value2.serial_number) {
          optionName = value2.serial_number;
        }

        if (currentItem) {
          var prevent_recursion = blueprint.prevent_recursion;

          if (currentItem.id !== value2.id && prevent_recursion) {
            console.log(currentItem.id, value2);

            return <Option value={value2.id}>{optionName}</Option>;
          } else {
            return <Option value={value2.id}>{optionName}</Option>;
          }
        } else {
          return <Option value={value2.id}>{optionName}</Option>;
        }
      });

      return optionsList;
    }
  };

  const renderSelect = () => {
    // console.log(schema)
    switch (mode) {
      case "options":
        return (
          <Select
            value={value}
            onChange={(val, option) => {
              changesMade(val, option);
            }}
            loading={loading}
            // onSearch={(e) => {
            //   getCurrentOptions(e);
            // }}
            showSearch
            allowClear={true}
            optionFilterProp="children"
            placeholder={"Select a " + blueprint.title}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {renderOptions()}
          </Select>
        );

      case "options-multiple":
        return (
          <Select
            mode="multiple"
            value={value}
            onChange={(val, option) => {
              changesMade(val, option);
            }}
            loading={loading}
            // onSearch={(e) => {
            //   getCurrentOptions(e);
            // }}
            showSearch
            allowClear={true}
            optionFilterProp="children"
            placeholder={"Select a " + blueprint.title}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {renderOptions()}
          </Select>
        );

      case "fixed-options":
        return (
          <Select
            value={value}
            onChange={(val, option) => {
              changesMade(val, option);
            }}
            allowClear={true}
            placeholder={"Select a " + blueprint.title}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {blueprint.choices.map((op) => {
              return <Option value={op.value}>{op.label}</Option>;
            })}
          </Select>
        );

      default:
      // code block
    }
  };

  return renderSelect();
};

export default Index;
